<template>
  <div v-click-outside="closeDropdown" class="vehicle-history">
    <button :class="['vehicle-history__toggler', { 'vehicle-history__toggler--is-open': isDropdownOpen }]" @click="toggleDropdown()">
      {{ tStatic('vehicleHistoryVisited') }}
    </button>

    <div :class="['vehicle-history-content', { 'vehicle-history-content--is-open': isDropdownOpen }]">
      <div class="vehicle-history-content__top">
        <h3 class="vehicle-history-content__title">
          {{ tStatic('vehicleHistoryRecentlyVisited') }}
        </h3>

        <button class="vehicle-history-content__close" @click="toggleDropdown()">
          <oie-use-svg svg="circle-plus" class="svg--45"></oie-use-svg>
        </button>
      </div>

      <div v-if="visitedVehicles && visitedVehicles.length > 0" class="vehicle-history-content__visited">
        <ul class="vehicle-history-content__list">
          <template v-for="(item, i) of visitedVehiclesReversed">
            <li v-show="isVehicleVisible(i)" :key="item.itemId" class="vehicle-history-content__item">
              <button class="vehicle__action" @click="goToVehicle(item.url)">
                {{ item.brand }}, {{ item.displayName }}

                <span v-if="isAuthenticated" class="vehicle__action-star" @click.stop="toggleFavoriteVehicle(item.itemId)">
                  <oie-use-svg svg="star-fill" :color="favoriteVehicles !== null && isFavoriteVehicle(item.itemId) ? '#006DB6' : '#A2A2A2'"></oie-use-svg>
                </span>
              </button>
            </li>
          </template>
        </ul>

        <button v-show="visitedVehicles.length > visibleVehiclesCount" class="vehicle-history-content__visited-toggler" @click="toggleVisitedVehicles()">
          {{ !isVisibleVehiclesOpen ? tStatic('showMoreLink') : tStatic('closeLink') }}
        </button>
      </div>

      <div v-click-outside="closeSavedDropdown" :class="['vehicle-favorites', { 'vehicle-favorites--is-open': isSavedDropdownOpen }]">
        <button class="vehicle__action vehicle__action--dropdown-toggler" :disabled="!hasFavoriteVehicles" @click="toggleFavoriteDropdown()">
          <template v-if="hasFavoriteVehicles">
            {{ tStatic('vehicleFavoritesSavedVehicles') }}
          </template>

          <template v-else>
            {{ tStatic('vehicleFavoritesNoSavedVehicles') }}
          </template>
        </button>

        <div v-if="isSavedDropdownOpen" class="vehicle-favorites__content">
          <template v-for="favorite of favoriteVehiclesReversed">
            <button :key="favorite.itemId" class="vehicle__action vehicle__action--url" @click="goToVehicle(favorite.url)">
              {{ favorite.brand }}, {{ favorite.displayName }}

              <span v-if="isAuthenticated" class="vehicle__action-star" @click.stop="toggleFavoriteVehicle(favorite.itemId)">
                <oie-use-svg svg="star-fill" color="#006DB6"></oie-use-svg>
              </span>
            </button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data: () => ({
    visibleVehiclesCount: 4,
    isVisibleVehiclesOpen: false,
    isDropdownOpen: false,
    isSavedDropdownOpen: false,
    isAuthenticated: false
  }),
  computed: {
    ...mapGetters('favorites', ['favoriteVehicles', 'isFavoriteVehicle', 'visitedVehicles', 'isVehicleLatestVisit']),
    visitedVehiclesReversed() {
      return [...this.visitedVehicles].reverse()
    },
    favoriteVehiclesReversed() {
      return [...this.favoriteVehicles].reverse()
    },
    hasFavoriteVehicles() {
      return this.favoriteVehicles && this.favoriteVehicles.length > 0
    }
  },
  mounted() {
    this.isAuthenticated = this.clientModel.uniqueId !== null && this.clientModel.isAuthenticated

    if (this.isAuthenticated && (this.favoriteVehicles === null || this.favoriteVehicles === undefined)) {
      this.getFavoriteVehicles()
    }

    this.getVisitedVehicles(this.isAuthenticated ? this.clientModel.uniqueId : null)

    if (this.clientModel.currentVehicle && !this.isVehicleLatestVisit(this.clientModel.currentVehicle.itemId)) {
      if (this.isAuthenticated) {
        this.addAuthenticatedVehicleVisit({
          userId: this.clientModel.uniqueId,
          vehicle: this.clientModel.currentVehicle
        })
      } else {
        this.addAnonymousVehicleVisit(this.clientModel.currentVehicle)
      }
    }
  },
  methods: {
    ...mapActions('favorites', ['getFavoriteVehicles', 'addFavoriteVehicle', 'deleteFavoriteVehicle', 'addAuthenticatedVehicleVisit', 'addAnonymousVehicleVisit', 'getVisitedVehicles']),
    closeDropdown() {
      if (this.isDropdownOpen) {
        this.isDropdownOpen = false
      }
    },
    closeSavedDropdown() {
      if (this.isSavedDropdownOpen) {
        this.isSavedDropdownOpen = false
      }
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
    },
    isVehicleVisible(i) {
      return !this.isVisibleVehiclesOpen ? i <= this.visibleVehiclesCount && !this.isVisibleVehiclesOpen : true
    },
    toggleVisitedVehicles() {
      this.isVisibleVehiclesOpen = !this.isVisibleVehiclesOpen
    },
    toggleFavoriteVehicle(id) {
      if (this.favoriteVehicles !== null && this.isFavoriteVehicle(id)) {
        this.deleteFavoriteVehicle(id)
      } else {
        this.addFavoriteVehicle(id)
      }
    },
    goToVehicle(url) {
      window.location.href = url
    },
    toggleFavoriteDropdown() {
      this.isSavedDropdownOpen = !this.isSavedDropdownOpen
    }
  }
}
</script>

<style lang="scss">
.vehicle-history {
  position: relative;
  display: inline-block;
  z-index: 4;
}

.vehicle-history__toggler {
  @include body-smaller;
  @include reset-button;
  position: relative;
  align-items: center;
  min-width: 13.75rem;
  width: 100%;
  height: 2.5rem;
  padding: measure(quarter) measure(half);
  background-color: color(background-gray-4);

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 0.625rem;
    background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.875 6.147L12.064.093l1.294 1.25-6.483 7.564L.397 1.348 1.692.098z' fill='%23757272' fill-rule='nonzero'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    width: 0.4625rem;
    height: 0.3125rem;
    transform: translateY(-50%);
    transition: transform 140ms ease-out;
  }

  &:hover {
    cursor: pointer;
  }
}

.vehicle-history__toggler--is-open::after {
  transform: translateY(-50%) scale(-1);
  transition: transform 140ms ease-in;
}

.vehicle-history-content {
  position: absolute;
  top: 100%;
  right: 0;
  left: 0;
  margin-top: measure(eighth);
  padding: measure(half);
  background-color: color(background-white);
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, .5);
  opacity: 0;
  visibility: hidden;
  transform: translateY(1rem);
  transition: opacity 180ms, visibility 180ms, transform 280ms;
  transition-timing-function: ease-in;

  @include media(small) {
    left: initial;
    width: 23.75rem;
  }
}

.vehicle-history-content--is-open {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  transition: opacity 180ms, visibility 180ms, transform 280ms;
  transition-timing-function: ease-out;
}

.vehicle-history-content__top {
  display: flex;
  margin-bottom: measure(half);
}

.vehicle-history-content__title {
  @include body-semi-bold;
  margin: 0;
}

.vehicle-history-content__close {
  @include reset-button;
  margin-left: auto;

  > svg {
    width: 1.25rem;
    height: 1.25rem;
  }
}

.vehicle-history-content__list {
  @include reset-list;
  max-height: 30rem;
  margin-bottom: measure(quarter);
  overflow: auto;
}

.vehicle-history-content__item:not(:last-child) {
  margin-bottom: measure(eighth);
}

.vehicle-history-content__visited-toggler {
  @include reset-button;
  @include reset-link;
  @include caption-semi-bold;
  color: color(text-blue);
  margin-left: auto;
}

.vehicle__action {
  position: relative;
  @include reset-button;
  width: 100%;
  min-height: 2.5rem;
  margin-bottom: measure(eighth);
  padding: measure(eighth) calc(#{measure(eighth)} + 2rem) measure(eighth) measure(half);
  background-color: color(background-gray-5);
  border: 1px solid color(border-gray);
  border-radius: 0.1875rem;
  text-align: left;
  overflow: hidden;
}

.vehicle__action-star {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  margin-left: auto;
  transition: background-color 140ms ease;
  border-radius: 0 0.1875rem 0.1875rem 0;

  &:hover {
    background-color: color(blue-4);
  }
}

.vehicle__action-star:hover svg {
  transform: scale(1.3);
  transition: transform 140ms ease;
}

.vehicle__action--dropdown-toggler {
  min-height: auto;
  height: 2.5rem;
  margin-bottom: 0;
  padding-right: 0;
  background-color: transparent;

  &::after {
    @include background-svg(caretDarkGray);
    content: '';
    display: inline-block;
    margin-left: auto;
    width: 2rem;
    height: 100%;
    background-size: 0.675rem 0.7625rem;
    background-position: center;
    background-repeat: no-repeat;
    transition: transform 180ms;
    transform: rotate(90deg);
    transform-origin: center center;
    transition: transform 140ms ease;
  }
}

.vehicle__action--dropdown-toggler[disabled]::after {
  opacity: .25;
}

.vehicle-favorites--is-open .vehicle__action--dropdown-toggler::after {
  transform: rotate(90deg) scale(-1);
}

.vehicle__action--url {
  text-decoration: none;
  border: none;
  background-color: transparent;
  color: color(text);
}

.vehicle__action--url .vehicle__action-star {
  background-color: transparent;
}

.vehicle-favorites {
  margin-top: measure(half);
}

.vehicle-favorites__content {
  display: flex;
  flex-direction: column;
  padding: measure(quarter) 0;
  border: 1px solid color(border-gray);
  border-radius: 3px;
  box-shadow: 0 0 4px 0 rgba(0,0,0,.3);
}
</style>
